import React, { useState, useEffect, useContext } from 'react';
import { translate } from 'react-multi-lang';
import { SyncOutlined } from '@ant-design/icons';
import { Alert, Tabs, Button, Row, Col, Typography, Card, Modal, Image, Form, Select } from 'antd';
import { AllHtmlEntities } from 'html-entities';

import ContainerPagina from '../../../components/ContainerPagina';
import TitolPagina from '../../../components/TitolPagina';
import Empresa from '../../../components/perfils/pares/Empresa';
import { Api } from '../../../helpers';
import { PerfilUsuariContext } from "../../../context/perfil-usuari";

const { Title, Paragraph } = Typography;
const entities = new AllHtmlEntities();

function Empreses(props){
  const [accio, setAccio] = useState('editar');
  const [empresaTridada, setEmpresaTriada] = useState({});
  const [perfilUsuari, setPerfilUsuari] = useContext(PerfilUsuariContext);
  const [dadesEmpreses, setDadesEmpreses] = useState([]);
  const [dadesEmpresesFiltrades, setDadesEmpresesFiltrades] = useState([]);
  const [llistaEmpresesFiltrades, setLlistaEmpresesFiltrades] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);

  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [id_categoria, setId_categoria] = useState(0);

  useEffect(() => {
    buscarDades();
    buscarDadesCategoria();
  },[]);

  useEffect(() => {

    if(id_categoria === 0){
      setDadesEmpresesFiltrades(dadesEmpreses);
    }else{
      const filtrat = dadesEmpreses.filter((element, index, arr) => element.id_categoria === id_categoria);
      setDadesEmpresesFiltrades(filtrat);
    }


  },[id_categoria, dadesEmpreses]);

  useEffect(() => {
    console.log('dadesEmpresesFiltrades', dadesEmpresesFiltrades)
    dadesPerPintar(dadesEmpresesFiltrades);
  },[dadesEmpresesFiltrades, props.t('idioma')]);

  const triarEmpresa = (item) =>{
    setEmpresaTriada(item);
    setAccio('editar');
    setModalVisible(true);
    //console.log(item)
  }

  const tancarModal = e =>{
    setModalVisible(false);
  }

  const dadesPerPintar = (dades) =>{

    let llista_e = [];

    dades.map((item) =>{

      item.descripcio = entities.decode(eval("item.descripcio_"+props.t('idioma')))
      item.oferta = entities.decode(eval("item.oferta_"+props.t('idioma')))

      const desc = <Paragraph ellipsis={true}>{item.descripcio}</Paragraph>;
      //cover={<img className="img-responsive" alt={entities.decode(item.nom)} src={item.logo} style={{maxHeight: '200px', width: 'auto', maxWidth: '400px', height: 'auto'}}/>}
      //cover={<Image src={item.logo} style={{maxHeight: '200px', width: 'auto'}}/>}
      //style={{height: 300, margin: 10}}
      llista_e.push(
        <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4} key={item.id}>
          <Card
            onClick={(e) => triarEmpresa(item)}
            hoverable
            //style={{minHeight: 300, maxHeight: 300, margin: 10}}
            style={{height: 300, margin: 10, textAlign: 'center'}}
            cover={<Image preview={false} src={item.logo} width='auto' style={{display: 'block', marginLeft: 'auto', marginRight: 'auto', maxHeight: 200, padding: 10 }}/>}
          >
            <Card.Meta style={{whiteSpace: 'pre-line'}} title={entities.decode(item.nom)} description={desc}/>
          </Card>
        </Col>
      );

    });
    setLlistaEmpresesFiltrades(llista_e);


  }

  const buscarDades = async () => {
      setIsLoading(true);
      const emp = await Api.get(`/empreses`);

      if(emp.result.success===1){

        setDadesEmpreses(emp.data.empreses);
      }
      setIsLoading(false);
  }

  const buscarDadesCategoria = async () => {
      const cat = await Api.get('/empreses/categories');
      if(cat.result.success===1){
        let llista_cat = [];
        console.log('Categories: ',cat)
        llista_cat.push(
          <Select.Option key={0} value={0}>
            {props.t('generic.all')}
          </Select.Option>
        );
        cat.data.categories.map((item) =>{
              llista_cat.push(
                <Select.Option key={item.id} value={item.id}>
                  {entities.decode(eval('item.nom_'+props.t('idioma')))}
                </Select.Option>
              );
        });
        setCategoriesOptions(llista_cat);
      }
    }


  return (

      <div style={{marginTop:'1rem', marginLeft:'2rem', marginRight: '2rem'}}>
      <Form.Item style={{marginBottom: 10}} label={props.t('medic.categoria')}>
        <Select defaultValue={id_categoria} value={id_categoria} onChange={setId_categoria}>
          {categoriesOptions}
        </Select>
      </Form.Item>
      {
        isLoading ? <SyncOutlined spin title="Loading..." style={{fontSize: '3rem'}} /> :
        <Row style={{backgroundColor: '#e0e0e0'}}>

          {llistaEmpresesFiltrades}

        </Row>
      }

      <Modal
        key="pares"
        title={accio==='editar' ? <h2>{entities.decode(empresaTridada.nom)}</h2> : props.t('generic.add')}
        open={modalVisible}
        footer={null}
        onCancel={tancarModal}
        width={1080}
        style={{top:20}}
        //bodyStyle={{ height: "90vh", overflow: "auto" }}
        destroyOnClose={true}
        forceRender={true}
      >

        <Empresa item={empresaTridada} callback={tancarModal} modal={true}/>
      </Modal>
      </div>
  );
}

export default translate(Empreses);
